module.exports = function(elm) {
  require("./password_rules.coffee");
  require("./elm");

  require("./checkboxes.coffee");
  require("./click_to_copy_link.coffee");
  require("./clipboard_listener.coffee");
  require("./cocoon_additions.coffee");
  require("./disabled_buttons.coffee");
  require("./handle_disable.coffee");
  require("./inputs.coffee");
  require("./js_depend.coffee");
  require("./remote_with_feedback.coffee");
  require("./signatures.coffee")(elm);
  require("./switch_input.coffee");
  require("./socket_subscriber.coffee");
  require("./select2-init.coffee");
};
